export default "__VITE_ASSET__f151c3f7__"